import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref } from 'vue';
import { useAuthStore } from '@/app/store/authStore';
import { BrandingImageType } from 'ah-api-gateways';
import UserLogin from '@/app/components/session/UserLogin.vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstLoginView',
  setup(__props) {

const theme = getCurrentInstance()?.proxy.$theme;

const authStore = useAuthStore();

const router = useRouter();

const stage = ref<string | null>(null);

const splashLogoLink = computed(() => {
  return theme?.val?.logos.find((l) => l.type === BrandingImageType.SPLASH_IMAGE)?.link;
});

function onLoginSuccess() {
  let path = authStore.isClientUser ? '/dashboard' : '/admin';
  router.push({ path });
}

return { __sfc: true,theme, authStore, router, stage, splashLogoLink, onLoginSuccess, UserLogin }
}

})